import { PRD4010_R01CardData } from "./Dto_PRD4010_R01";

interface Props {
    data: PRD4010_R01CardData;
    lineImage?: string;
}

export const LineCard_PRD4010_R01 = ({ data, lineImage }: Props) => {
    const isWorking = data.hasPlcData && data.inQty > data.productionQty;
    const workplaceName = data.workplaceNm || "";
    const isReflowLine =
        workplaceName.includes("수삽") ||
        workplaceName.toUpperCase().includes("PBA");

    const statusImage =
        lineImage ||
        (isReflowLine
            ? isWorking
                ? "/images/smt/reflow_oven_active.png"
                : "/images/smt/reflow_oven_idle.png"
            : isWorking
                ? "/images/smt/smt_line_active.png"
                : "/images/smt/smt_line_idle.png");

    const headerBg = isWorking ? "bg-[#d4edda]" : "bg-[#e0e0e0]";
    const dotColor = isWorking ? "bg-red-500" : "bg-gray-400";
    const statusText = isWorking ? "작업중" : "작업대기";
    const cardOpacity = isWorking ? "" : "opacity-80";

    const formatTime = (t?: string) => {
        if (!t) return "-";
        return t.length >= 5 ? t.substring(0, 5) : t;
    };

    const itemDisplay = [data.itemNm, data.itemSpec].filter(Boolean).join(" / ");

        return (
        <div
            className={`border border-gray-300 rounded w-[calc(50%-8px)] min-w-[300px] ${cardOpacity}`}
        >
            <div className={`flex items-center justify-between px-4 py-3 ${headerBg}`}>
                <span className="text-lg font-bold">
                    {data.workplaceNm}&nbsp;&nbsp;{statusText}
                </span>
                <span className={`w-4 h-4 rounded-full ${dotColor}`} />
            </div>

            <div className="flex items-center justify-center bg-white h-[180px]">
                {statusImage ? (
                    <img
                        src={statusImage}
                        alt={data.workplaceNm}
                        className="h-full object-contain"
                        style={isReflowLine ? { transform: `scaleX(1.0)` } : undefined}
                    />
                ) : (
                    
                    <span className="text-gray-300 text-sm">이미지 준비중</span>
                )}
            </div>

            {itemDisplay ? (
                <div className="bg-[#fff9e6] border-t border-gray-200 px-3 py-2 text-lg text-center font-medium">
                    {itemDisplay}
                </div>
            ) : null}

            <table className="w-full border-t border-gray-200 text-[34px]">
                <tbody>
                    <tr className="border-b border-gray-200">
                        <td className="py-2 px-3 text-gray-600 border border-gray-400  br-gray-500 w-[10%] text-center text-[20px] font-bold">자재공급</td>
                        <td className="px-3 py-2 font-bold border border-gray-400   w-[30%]   text-center text-[20px] ">
                            {data.inQty ?? 0}
                        </td>
                        <td className="py-2 px-3 text-gray-600 border border-gray-400  br-gray-200 w-[10%] text-center text-[20px] font-bold">생산</td>
                        <td className="px-3 py-2 font-bold  border border-gray-400  w-[30%]  text-center text-[20px] ">
                            {data.productionQty ?? 0}
                        </td>
                    </tr>
                    <tr>
                        <td className=" py-2  px-3 text-gray-600 border border-gray-400  br-gray-500 w-[10%] text-center text-[20px] font-bold">작업자</td>
                        <td className="px-3 py-2 text-gray-600 border border-gray-400 w-[30%] br-gray-200  text-center text-[20px] font-bold" >
                            {data.empNm || "-"} 
                        </td>
                        <td className="py-2 px-3 text-gray-600 border border-gray-400  br-gray-500 w-[10%] text-center text-[20px] font-bold">작업시간</td>
                        <td className="px-3 py-2 text-gray-500  border border-gray-400 w-[30%] br-gray-200   text-center text-[20px] " >
                            {data.fromTime
                                ? `${formatTime(data.fromTime)} ~ 현재`
                                : "~"}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
